



























































import {
  defineComponent,
  onBeforeMount,
  reactive,
  SetupContext,
  watch,
  computed,
} from '@vue/composition-api';
import EntityDialog from '@/components/common/EntityDialog.vue';
import { PreorderProduct } from '@/models/entities/PreorderProduct';

interface Props {
  id: string;
}

interface State {
  entity: PreorderProduct;
  loading: boolean;
}

const Component = defineComponent({
  name: 'PreorderProductDialog',

  components: {
    EntityDialog,
  },

  props: {
    id: String,
  },

  setup(props: Props, { root: { $store, $router } }: SetupContext) {
    let preorderProduct = new PreorderProduct({});

    onBeforeMount(async () => {
      const res = await $store.dispatch(`preorderProductsModule/fetchItem`, props.id);
      if (!res) $router.back();
    });

    const state = reactive({
      entity: preorderProduct,
      loading: computed(() => $store.getters['preorderProductsModule/loading']),
    }) as State;

    watch(
      () => $store.getters['preorderProductsModule/selectedItem'],
      (newValue: PreorderProduct) => Object.assign(preorderProduct, newValue),
      { immediate: false, deep: true },
    );

    const title = computed(() => {
      if (state.loading) return '';
      return `Edit ${$store.getters['preorderProductsModule/selectedItem']?.title}`;
    });

    const rules = {
      number: [(v: number) => v >= 0 || 'Only positive numbers allowed'],
    };

    return {
      state,
      title,
      rules,
    };
  },
});
export default Component;
